import type { PropsWithChildren, ReactNode } from 'react';

import { css } from '@compiled/react';

import { media } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { JSMOverlayTemplate } from '@/components/signup/layouts/product-overlay-template';
import { ServiceCollectionAtlassianLogo } from '@/components/signup/utils/logos/service-collection-atlassian-logo';

type JsmUseCaseOnboardingContainerProps = PropsWithChildren<{
	header: string;
	subheader: string;
	isJsmCrossflow?: boolean;
	topLeftAction?: ReactNode;
}>;

export const JsmUseCaseOnboardingContainer = ({
	children,
	header,
	subheader,
	isJsmCrossflow,
	topLeftAction,
}: JsmUseCaseOnboardingContainerProps) => (
	<JSMOverlayTemplate
		header={header}
		headerLogo={<ServiceCollectionAtlassianLogo />}
		subheader={subheader}
		size="md"
		showBrandFooter={false}
		hideLogo
		isJsmCrossflow={isJsmCrossflow}
	>
		{topLeftAction && <div css={topLeftActionWrapperStyles}>{topLeftAction}</div>}
		{children}
	</JSMOverlayTemplate>
);

const topLeftActionWrapperStyles = css({
	marginBlockEnd: token('space.300'),
	[media.above.sm]: {
		position: 'absolute',
		insetBlockStart: token('space.400'),
		insetInlineStart: token('space.400'),
		marginBlockEnd: token('space.0'),
	},
});
